import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { styled } from "styled-components";

import LogoLoca from "../../styles/images/logo_loca_big.svg";
import LogoMobiligent from "../../styles/images/logo_mobiligent_big.svg";
import LogoD2e from "../../styles/images/logo_d2e_big.svg";
import LogoBoatrang from "../../styles/images/logo_boatrang_big.svg";
import LogoGreego from "../../styles/images/logo_greego_big.svg";
import LogoTau from "../../styles/images/logo_tau_big.svg";

import { TextDiv } from "../../styles/Common";
import { useDispatch, useSelector } from "react-redux";
import { mainActions } from "../../store/slices/mainSlice";

const PointChangeList = (props) => {
  const logos = [
    { src: LogoLoca, alt: "loca Logo" },
    { src: LogoMobiligent, alt: "mobiligent Logo" },
    { src: LogoD2e, alt: "d2e Logo" },
    { src: LogoBoatrang, alt: "boatrang Logo" },
    { src: LogoGreego, alt: "greego Logo" },
    { src: LogoTau, alt: "tau Logo" },
  ];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector((state) => state.main.affiliateList);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    const params = {};
    dispatch(mainActions.fetchAffiliateList({ params }));
  };

  return (
    <ListWrap>
      <PointChangeTextDiv>
        <h3>포인트 교환</h3>
        <p>제휴사의 포인트를 뮤포인트로 교환해보세요!</p>
      </PointChangeTextDiv>

      <ul>
        {data &&
          data.count > 0 &&
          data.list.map((logo, index) => (
            <li key={index}>
              <List
                className="pointer"
                onClick={() => {
                  navigate("/point/change");
                }}
              >
                <LogoWrap>
                  <img src={logo.image} alt={logo.alt} />
                </LogoWrap>
              </List>
            </li>
          ))}
      </ul>
    </ListWrap>
  );
};

export default PointChangeList;
const baseMarginTop = "1.4rem";

const ListWrap = styled.div`
  padding: 3rem 2rem;
  text-align: left;

  ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: ${baseMarginTop};
  }

  li {
    width: 50%;
    margin-top: ${baseMarginTop};
    text-align: center;
    &:nth-of-type(even) > div {
      margin-left: 0.8rem;
    }
  }
`;

const List = styled.div`
  /* min-width: 7.2rem; */
  width: calc(100% - 0.8rem);

  @media screen and (max-width: 375px) {
    min-width: 0;
  }
`;

const LogoWrap = styled.div`
  width: 100%;
  /* height: 7.2rem; */
  /* min-height: 7.2rem; */
  border-radius: 10px;
  background: ${({ theme }) => theme.color.white};
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 100%;
    /* max-height: 100%; */
  }
`;
const PointChangeTextDiv = styled(TextDiv)`
  text-align: left;
  h3 {
    font-size: 2.2rem;
    line-height: 2.5rem;
    color: ${({ theme }) => theme.color.purple_text};
  }
  p {
    font-size: 1.6rem;
    line-height: 1.8rem;
    color: ${({ theme }) => theme.color.purple_text};
    margin-top: 0.9rem;
  }
`;
